export { CustomCheckbox } from "@shared/src/components/ui/common/form-components/CustomCheckbox";
export { CustomCheckbox as default } from "@shared/src/components/ui/common/form-components/CustomCheckbox";
